<div class="row">
  <div class="col-12">
    <div class="card mt-5">
      <div class="card-body">
        <div class="col-lg-3 mb-4 mt-4 mx-auto">
          <div class="text-center">
            <img
              class="card-img img-fluid"
              src="assets/images/homepage/benchmark-logo-2.png" />
          </div>
        </div>

        <h6 class="mb-3" style="color: rgb(5, 78, 128) !important">
          Resident <i class="bx bx-user-pin"></i>
          <span class="text-muted"> {{ completeName() }}</span>
        </h6>

        <div class="row">
          <ng-template appForms></ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
